import { useQuery } from "@tanstack/react-query";

import { consultationsQueriesStore } from "@/features/consultations/api/queries";
import { useScheduleContext } from "@/features/consultations/contexts";

export const useProvidersQuery = () => {
  const { state, language, appointmentType } = useScheduleContext();

  return useQuery(
    consultationsQueriesStore.consultations.providers._ctx.list._ctx.openLoop({
      state,
      language,
      appointmentType,
    }),
  );
};
